export const customStylesMobile = {
	content: {
		width: '100%',
		maxWidth: '1024px',
		height: '586px',
		left: '50%',
		right: '50%',
		transform: 'translate(-50%)',
		bottom: '0',
		top: 'auto',
		overflow: 'hidden',
		background: 'rgba(236, 241, 249, 0.9)',
		boxShadow: '0px -4px 15px rgba(86, 111, 254, 0.15)',
		borderRadius: '16px 16px 0px 0px',
		boxSizing: 'borderBox',
		borderLeft: "none",
		borderRight: "none",
		borderBottom: "none"
	},
	overlay: {
		background: 'rgba(8, 15, 32, 0.6)',
		backdropFilter: 'blur(5px)'
	}
};
